import { FC } from 'react';
import { Section } from './ui/Section';
import type { Language } from '../types/cv';

interface Props {
  languages: Language[];
  title?: string;
}

export const Languages: FC<Props> = ({ languages, title = 'Languages' }) => (
  <Section title={title}>
    <p>
      {languages
        .map(l => (l.fluency ? `${l.language} (${l.fluency})` : l.language))
        .filter(Boolean)
        .join(' · ')}
    </p>
  </Section>
);

export default Languages;
